module.exports = '<svg width="36" height="32" viewBox="0 0 36 32"><path d="M34 4h-6V2c0-1.106-.894-2-2-2H10C8.894 0 8 .894 8 2v2H2C.894 4 0 4.894 0 6v4c0 3.214 2.13 8 8 8 .274 0-.238.1 0 0 1.262 3.016 4.726 5.13 8 5.796V28h-2c-2.208 0-4 1.792-4 4h16c0-2.208-1.792-4-4-4h-2v-4.204c3.274-.666 6.738-2.782 8-5.796.238.1-.274 0 0 0 5.87 0 8-4.786 8-8V6c0-1.106-.894-2-2-2zM4 10V8h4v6c-3.652 0-3.984-3.072-4-4zm28 0c0 .668-.194 4-4 4V8h4v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/trophy-1.js
// module id = 1460
// module chunks = 14